import {
  AdminLogout,
  EmployeeLogout,
  ParentLogout,
  StudentLogout,
} from '../api/logout/logoutService';
import { logout } from '../features/auth/authSlice';
import { toast } from 'react-toastify';
import { ROUTES } from '../constants/routes';
import Cookies from 'js-cookie';

export const handleLogout = async (dispatch, user, navigate, reason, showSnackbar) => {
  const { PARENTSIGNIN, ADMINSIGNIN, EMPLOYEESIGNIN, STUDENTSIGNIN } = ROUTES;
  const role = user?.roleName?.toLowerCase();

  if (!user) return;
  try {
    switch (role) {
      case 'employee': {
        await EmployeeLogout(user?.roleName);
        break;
      }

      case 'parent': {
        await ParentLogout(user?.roleName);
        break;
      }

      case 'student': {
        await StudentLogout(user?.roleName);
        break;
      }

      default: {
        await AdminLogout(user?.roleName);
        break;
      }
    }

    localStorage.setItem('lastRole', role);
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('refreshTokenExpiry');
    dispatch(logout());

    const loginRedirectMap = {
      parent: PARENTSIGNIN,
      employee: EMPLOYEESIGNIN,
      student: STUDENTSIGNIN,
      admin: ADMINSIGNIN,
    };
    const roleName = localStorage.getItem('lastRole');
    navigate(loginRedirectMap[roleName] || ADMINSIGNIN, { replace: true });

    if (typeof showSnackbar === 'function') {
      if (reason === 'manual') {
        // showSnackbar('You have logged out successfully.', 'success');
      } else if (reason === 'session-expired') {
        // showSnackbar('Session expired. Please log in again.', 'info');
      }
    }
  } catch (error) {
    if (typeof showSnackbar === 'function') {
      // showSnackbar(error.message || 'Something went wrong during logout.', 'error');
    }
  }
};
